import { gql } from "@apollo/client";

export const QUERY_LOADS_MATCH_TO_TRUCK = gql`
  query LoadsMatchToTruck($truckId: String) {
    loadsMatchToTruck(truckId: $truckId) {
      totalCount
      data {
        timePosted
        modfied
        id
        originAddress
        destinationAddress
        originCity
        destinationCity
        originState
        destinationState
        originCountry
        destinationCountry
        originIso2
        originIso3
        destinationIso2
        destinationIso3
        originZip
        originAreacode
        destinationZip
        destinationAreacode
        trailerType
        length
        weight
        targetRate
        timeStart
        timeEnd
        timeDelivery
        matchDate
        details
        recentBid
        linehaulRate
        linehaulDistance
        linehaulDuration
        linehaulRoute
        costPerMile
        linehaulCpm
        cargoValue
        userLoadNumber
        isDeleted
        isRateIndex
        originLocations
        destinationLocations
        attachments
        userType
        postTo
        groups
        groupsPostTo
        status
        modified
        created
        loadId
        originCoords {
          latitude
          longitude
        }
        destinationCoords {
          latitude
          longitude
        }
        user {
          id
          email
          userType
          contactName
          contactEmail
          address
          city
          state
          country
          contactPhone
          mc
          dot
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
